/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import home from "../../assets/image.png";
import team1 from "../../assets/team1.png"
import paymentImage from "../../assets/payment-image.png";
import team2 from "../../assets/team2.png"
import ContactForm from "../../common/ContactForm/Contact";
import homepage from "../../assets/about/homepage.jpg";
import HeaderSection from "../../common/HeaderSection/Header";
import DonateToFood from "../../common/DonateToFood/DonateFood";
import Story from "../../common/Story/Story";
import Donate from "../../common/Donation/Donate";
import "./index.css";
import CarouselPage from "../../common/Carousel/CarouselPage";
import Homeimg1 from "../../assets/image.png";
import Homeimg2 from "../../assets/homes.jpg";
import Homeimg3 from "../../assets/homeimg2.jpg";

const Home = () => {
  const carouselImages = [
      { src: Homeimg1, alt: "First image ",style: { height: "600px", width: "100%", objectFit: "cover" } },
      { src: Homeimg2, alt: "Second image" ,style: { height: "600px", width: "100%", objectFit: "cover" }},
      { src: Homeimg3, alt: "Third image",style: { height: "600px", width: "100%", objectFit: "cover" } },
    ];
  return (
    <>
    <CarouselPage images={carouselImages}/>
      <HeaderSection image={home} text="E-Techno" longtext="Empowering Children for a Brighter Future"/>  
      <div className="team-container">
      <h2 className="team-title">Meet Our Team</h2>
      <div className="team-members">
        <div className="team-member">
        <img src={team2} alt="Nand Kishore Mahato" className="team-photo max-w-full rounded-lg mx-auto"/>
          <div className="team-info">
            <h3 className="team-role">PRESIDENT</h3>
            <h4 className="team-name">NAND KISHORE MAHATO</h4>
            <div className="qualification-box">
              <p className="team-qualifications">
                <strong>EDUCATIONAL QUALIFICATION:</strong> AMIE(I) Mining
                Engineering, MA(Mathematics), B.Ed, Diploma in Software Engg,
                Diploma in French Language.
              </p>
            </div>
            <p className="team-email">Nand.Mahato@etechnoedu.org</p>
          </div>
        </div>
        <div className="team-member">
          <img
            src={team1}
            alt="Jaba Mahato"
            className="team-photo"
          />
          <div className="team-info">
            <h3 className="team-role">TREASURER</h3>
            <h4 className="team-name">JABA MAHATO</h4>
            <p className="team-qualifications qualification-box">
              <strong>EDUCATIONAL QUALIFICATION:</strong> BSc(Chemistry Hons),
              MSc(Chemistry), B.Ed.
            </p>
            <p className="team-email">Jaba.Mahato@etechnoedu.org</p>
          </div>
        </div>
      </div>
      </div>
      <div class="blocks">
        <div class="block">TAKING RESPONSIBILITY</div>
        <div class="block">MOBILISING POTENTIAL</div>
        <div class="block">INSPIRING COLLECTIVE ACTION</div>
      </div>
      <DonateToFood image={homepage} style={{width: "120%"}}  className="help-image"/>
     <div className="Ques">
        <div className="content-box">
          <div className="box">
            <h3>What we do?</h3>
            <p>
              E-techno is dedicated to creating a brighter future for children in need. 
              We strive to ensure that every child has access to quality education, 
              proper nutrition, and a safe environment where they can explore, learn, and grow. 
              Through high-impact programs, we work at the grassroots level to enable positive, 
              long-term change in children’s lives. Your support and generosity are crucial in 
              helping us make this vision a reality.
            </p>
          </div>
          <div className="box">
            <h3>Why Children?</h3>
            <p>
              Children are the foundation of our nation’s future, and it is essential to provide 
              them with the tools they need to reach their full potential. E-techno is committed 
              to empowering children by ensuring access to quality education, good nutrition, and 
              a safe environment. By investing in children today, we are investing in a brighter 
              tomorrow for all.
            </p>
          </div>
          <div className="box">
            <h3>How can you help?</h3>
            <p>
              With your support, E-techno addresses the critical needs of children by working 
              with parents, teachers, communities, and governments. Together, we aim to change 
              behaviors and practices at the grassroots level and influence public policy, 
              creating an ecosystem that truly prioritizes children as the future of our nation. 
              Your involvement helps us build a world where every child has the opportunity to thrive.
            </p>
          </div>
        </div>
      </div>
     <Donate text="We rise by lifting others" image={paymentImage}/>
       <Story />
      <ContactForm />
    </>
  );
};

export default Home;
